/* Service explanation: single-pass entrances and a natural-flow process. */
(() => {
  if (window.maincareServiceStory) return;
  window.maincareServiceStory = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const revealRootMargin = '0px 0px -10% 0px';
  const scenes = new Map();
  let frame = 0;
  const render = () => {
    frame = 0;
    if (reduced.matches) return;
    const updates = [];
    scenes.forEach(({ root, hero, image, steps }) => {
      if (!root.isConnected) return;
      if (hero && image) {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < innerHeight) {
          const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
          updates.push(() => { image.style.transform = 'scale(' + (1.025 - progress * .025) + ')'; });
        }
      }
      const positions = steps.map(step => step.getBoundingClientRect());
      let active = 0;
      positions.forEach((rect, index) => { if (rect.top < innerHeight * .58) active = index; });
      updates.push(() => steps.forEach((step, index) => step.toggleAttribute('data-active', index === active)));
    });
    updates.forEach(update => update());
  };
  const requestRender = () => { if (!frame && !reduced.matches) frame = requestAnimationFrame(render); };
  const discover = () => {
    document.querySelectorAll('[data-service-story]').forEach(root => {
      if (scenes.has(root)) return;
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.removeAttribute('data-service-pending');
        observer.unobserve(entry.target);
      }), { threshold: 0, rootMargin: revealRootMargin });
      if (!reduced.matches && !window.Shopify?.designMode) {
        root.querySelectorAll('[data-service-reveal]').forEach((element, index) => {
          // Never hide content already in view or on a restored scroll position.
          if (element.getBoundingClientRect().top < innerHeight) return;
          element.setAttribute('data-service-pending', '');
          element.style.transitionDelay = (index % 3) * 50 + 'ms';
          observer.observe(element);
        });
      }
      const hero = root.querySelector('[data-service-depth]');
      scenes.set(root, { root, hero, image: hero?.querySelector('img'), steps: [...root.querySelectorAll('[data-service-step]')], observer });
    });
    requestRender();
  };
  if (typeof IntersectionObserver !== 'function') return;
  discover();
  addEventListener('scroll', requestRender, { passive: true });
  addEventListener('resize', requestRender, { passive: true });
  reduced.addEventListener('change', () => {
    scenes.forEach(({ root, image, observer, steps }) => {
      observer.disconnect();
      root.querySelectorAll('[data-service-pending]').forEach(element => element.removeAttribute('data-service-pending'));
      if (image) image.style.removeProperty('transform');
      steps.forEach(step => step.removeAttribute('data-active'));
    });
    requestRender();
  });
  document.addEventListener('shopify:section:load', discover);
  document.addEventListener('shopify:section:unload', event => {
    scenes.forEach((scene, root) => {
      if (!event.target.contains(root)) return;
      scene.observer.disconnect();
      scenes.delete(root);
    });
  });
})();
